import {
	clearAuthorizationToken,
	decodeClaimAuthorizationToken,
	getAuthorizationToken,
	isClaimAuthorizationToken,
} from "../auth/authToken";

const ACTIVE_MANAGED_COMPANY_STORAGE_KEY = "dproz_company_claim_active_company";

export function getClaimToken() {
	const authorizationToken = getAuthorizationToken();
	return isClaimAuthorizationToken(authorizationToken) ? authorizationToken : null;
}

export function decodeClaimToken(token = getClaimToken()) {
	return decodeClaimAuthorizationToken(token);
}

export function isAdminClaimSession(token = getClaimToken()) {
	return decodeClaimToken(token)?.role === "admin";
}

export function hasValidClaimSession(token = getClaimToken()) {
	const claimSession = decodeClaimToken(token);
	const expiresAt = claimSession?.expiresAt ? new Date(claimSession.expiresAt) : null;
	return Boolean(claimSession?.companyId && expiresAt && expiresAt.getTime() > Date.now());
}

export function getActiveManagedCompanyId() {
	if (typeof window === "undefined") return null;

	const companyId = window.localStorage.getItem(ACTIVE_MANAGED_COMPANY_STORAGE_KEY);
	return companyId?.trim() || null;
}

export function setActiveManagedCompanyId(companyId) {
	if (!companyId || typeof window === "undefined") {
		return;
	}

	window.localStorage.setItem(ACTIVE_MANAGED_COMPANY_STORAGE_KEY, companyId);
}

export function clearActiveManagedCompanyId() {
	if (typeof window === "undefined") {
		return;
	}

	window.localStorage.removeItem(ACTIVE_MANAGED_COMPANY_STORAGE_KEY);
}

export function getManagedCompanyId(token = getClaimToken()) {
	const claimSession = decodeClaimToken(token);
	if (!claimSession) return null;

	if (isAdminClaimSession(token)) {
		return getActiveManagedCompanyId();
	}

	return claimSession.companyId || null;
}

export function clearClaimSession() {
	clearActiveManagedCompanyId();
	clearAuthorizationToken();
}
